<template>
  <div>
    <div class="table-responsive">
      <table class="table table-borderless table-hover">
        <tr class="border-bottom" v-for="promotion in promotions" v-bind:key="promotion.id">
          <td class="p-0 py-3" style="min-width: 500px">
            <base-checkbox v-model="promotion.selection">
              <h5 class="text-uppercase">
                {{promotion.name}}
                <div class="badge badge-pill bg-primary text-white ml-1">{{promotion.code}}</div>
                <div v-if="['all', 'allFromBxi'].includes(promoTab)" class="badge badge-pill text-white ml-1" v-for="type in getSalesChannelStoreTypes(promotion.sales_channel_stores)" :class="[promotion_color[type]]">
                  {{capitalize(type)}}
                </div>
                <div v-if="promotion.from_bxi" class="badge badge-pill badge-primary ml-1">From BXI</div>
              </h5>
              <label>
                {{capitalize(promotion.application_type)}} •
                {{promotion.description}} •
                {{getSalesChannelStores(promotion.sales_channel_stores).join(" • ")}}
              </label>
            </base-checkbox>
          </td>
          <td class="p-0 py-3 cursor-pointer" @click="toggleDrawer(promotion.id)">
            <div v-if="promotion.promo_status" :class="[promo_status_color[promotion.promo_status]]" class="badge badge-pill mr-1">
              {{promotion.promo_status}}
            </div>
            <div v-if="promotion.export_status" :class="[export_status_color[export_status(promotion.export_status, promotion.syncing_errors, true)]]" class="badge badge-pill">
              {{export_status(promotion.export_status, promotion.syncing_errors)}}
            </div>
            <br>
            <label class="mt-1">
              {{promotion.data.starts_at | formatDate}}
              <span v-if="promotion.data._ends_at">
                 - {{promotion.data.ends_at | formatDate}}
              </span>
              <span v-else>
                 onwards
              </span>
            </label>
          </td>
          <td class="cursor-pointer" @click="toggleDrawer(promotion.id)">
            <div class="float-right py-3 px-2">
              <i class="fa fa-chevron-right"></i>
            </div>
          </td>
        </tr>
        <tr v-if="promotions.length === 0">
          <td class="p-0 py-4 text-center" style="font-size: 14px">
            <i class="fas fa-info-circle mr-2"></i>No available promotions
          </td>
        </tr>
      </table>
    </div>
    <div class="text-right" v-if="display_pagination">
      <span @click="changePage(1, true)" class="btn btn-nav cursor-pointer p-2 px-3 m-0 bg-white" :class="[current_page === 1 ? 'text-muted' : '']">«</span>
      <span @click="changePage(current_page - 1)" class="btn btn-nav cursor-pointer p-2 px-3 m-0 bg-white" :class="[current_page === 1 ? 'text-muted' : '']">‹</span>
      <span v-for="page in getPages(current_page)" v-bind:key="page">
        <span @click="changePage(page)" v-if="page <= total_pages" class="btn btn-nav cursor-pointer p-2 px-3 m-0" :class="[current_page === page ? 'bg-primary text-white' : 'bg-white']">
          {{page}}
        </span>
      </span>
      <span @click="changePage(current_page + 1)" class="btn btn-nav cursor-pointer p-2 px-3 m-0 bg-white" :class="[current_page === total_pages ? 'text-muted' : '']">›</span>
      <span @click="changePage(total_pages, true)" class="btn btn-nav cursor-pointer p-2 px-3 m-0 bg-white" :class="[current_page === total_pages ? 'text-muted' : '']">»</span>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      promotions: Array,
      promoTab: String,
      current_page: Number,
      total_pages: Number,
      display_pagination: Boolean
    },
    data() {
      return {
        promo_status_color: {
          active: 'badge-info',
          inactive: 'badge-danger'
        },
        export_status_color: {
          posted: 'badge-info',
          posted_with_errors: 'badge-warning',
          pending: 'badge-warning',
          saved: 'badge-success'
        },
        promotion_color: {
          online_store: 'bg-gradient-blue',
          shopify: 'bg-gradient-green',
          lazada: 'bg-gradient-purple',
          shopee: 'bg-gradient-prange'
        }
      }
    },
    methods: {
      capitalize: function(string) {
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
      },
      getSalesChannelStores: function(stores){
        return Object.entries(stores).map(val => this.capitalize(val[1]['name']))
      },
      getSalesChannelStoreTypes: function(stores){
        return Object.entries(stores).map(val => val[1]['sales_channel_type'])
      },
      toggleDrawer: function(id){
        this.$emit('openPromotion', {}, id);
      },
      export_status: function(status, errors, is_key){
        return status !== "posted" ? status : errors && errors.length === 0 ? status : is_key ? 'posted_with_errors' : "posted w/ errors"
      },
      getPages: function(page){
      	let range = []
      	let limit = 5
        page = parseInt(page) < 1 ? 1 : parseInt(page)

      	if(page < 4){
      		range = Array.from({length: limit},(k, inc) => inc + 1 )
      	}
      	else{
      		range = [
      			page - 2,
      			page - 1,
      			page,
      			page + 1,
      			page + 2
      		]
      	}
      	return range
      },
      changePage: function(page, skip){
        if(page > 0 && page <= this.total_pages && !skip){
          this.$emit('getPromotions', {}, page);
        }
      }
    },
    filters: {
      formatDate: function (dateString){
        try{
          let date = new Date(dateString)
          return date.toLocaleString('default', { month: 'short' }) + ' ' + date.getDate()
        }
        catch{
          return ''
        }
      }
    }
  }
</script>
<style>
  .custom-checkbox-label{
    color: rgb(82, 95, 127);
    font-family: Open Sans, sans-serif;
    font-size: 0.8rem;
    font-weight: 400;
    line-height: 1.5;
    white-space: nowrap;
    font-variant: tabular-nums;
    font-feature-settings: 'tnum';
  }
</style>
